import React from 'react'

export const BookingDashboardPage = React.lazy(() => import('./booking-dashboard'))

export const NewOneTimeBookingPage = React.lazy(() => import('./new-one-time-booking'))

export const NewOneTimeBookingPage2 = React.lazy(() => import('./new-one-time-booking2'))

export const NewContractBookingPage = React.lazy(() => import('./new-contract-booking'))

export const NewContractBookingPage2 = React.lazy(() => import('./new-contract-booking-2'))
